import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "submitButton",
    "documentFront",
    "documentBack"
  ];

  validateDocuments() {
    this.submitButtonTarget.disabled = !this.documentFrontTarget.value;
  }
}
